<template>
  <v-card class="mx-auto primary darken-1 pa-3" max-width="350">
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title>
          <span
            style="
              font-family: Roboto;
              font-style: normal;
              font-weight: bold;
              font-size: 1.25rem;
              line-height: 20px;
            "
            >AGORA</span
          >
          <v-tooltip top color="primary darken-1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                right
                class="mt-n1"
                small
                color="secondary lighten-1"
                v-bind="attrs"
                v-on="on"
                >mdi-help-circle-outline</v-icon
              >
            </template>
            <span
              class="my-4"
              style="
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 0.875rem;
                line-height: 18px;
              "
            >
              Dados estimados por modelo numérico
            </span>
          </v-tooltip>
        </v-list-item-title>
        <v-list-item-subtitle class="mt-2 white--text">
          <v-row>
            <v-col cols="2">
              <v-icon>mdi-map-marker-circle</v-icon>
            </v-col>
            <v-col cols="10">
              <span
                v-if="this.city"
                style="
                  font-family: Roboto;
                  font-style: normal;
                  font-weight: normal;
                  font-size: 0.875rem;
                "
              >
                {{ this.city.citname }}, <br v-if="this.city.citname.length > 13"> {{ this.day }} de {{ this.month }} de
                {{ this.year }}</span
              >
              <br />
              <span
                style="
                  font-family: Roboto;
                  font-style: normal;
                  font-weight: normal;
                  font-size: 0.875rem;
                "
                >{{ this.currentTime }}</span
              >
            </v-col>
          </v-row>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text class="white--text mt-n3">
      <v-row align="center" justify="center">
        <v-col cols="3">
          <v-icon size="68">{{this.icon}}</v-icon>
        </v-col>
        <v-spacer />
        <v-col cols="6">
          <span v-if="$vuetify.breakpoint.name === 'sm'" style="
              font-family: Roboto;
              font-style: normal;
              font-weight: bold;
              font-size: 24px;
            ">
            {{this.temp}}°C
          </span>
          <span
            v-else
            style="
              font-family: Roboto;
              font-style: normal;
              font-weight: bold;
              font-size: 3rem;
            "
          >
            {{this.temp}}°C
          </span>
        </v-col>
        <v-spacer />
        <v-col cols="12" class="mt-n6">
          <span
            style="
              font-family: Roboto;
              font-style: normal;
              font-weight: 500;
              font-size: 0.75rem;
            "
          >
            {{this.text}}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-list-item>
      <v-list-item-icon>
        <v-icon>icon-infohidro-termometro</v-icon>
        <v-list-item-content>
          <v-list-item-title>
            <span
              style="
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 1rem;
              "
            >
              {{
                this.calcThermalSensation(this.temp, this.wind, this.humidity)
              }}°C
            </span>
          </v-list-item-title>
          <br />
          <v-list-item-subtitle class="mt-n1 white--text">
            <span
              style="
                font-family: Roboto;
                font-style: normal;
                font-weight: 300;
                font-size: 0.875rem;
              "
              >Sensação Térmica</span
            >
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item-icon>
    </v-list-item>
    <v-list-item class="mt-n6 pb-n2">
      <v-list-item-icon>
        <v-icon>mdi-water-outline</v-icon>
        <v-list-item-content>
          <v-list-item-title>
            <span
              style="
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 1rem;
              "
            >
              {{ this.precIntensity }}mm
            </span>
          </v-list-item-title>
          <v-list-item-subtitle class="mt-n1 white--text">
            <span
              style="
                font-family: Roboto;
                font-style: normal;
                font-weight: 300;
                font-size: 0.875rem;
              "
              >Chuva acumulada</span
            >
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item-icon>
    </v-list-item>
    <v-list-item class="mt-n6 pb-n2">
      <v-list-item-icon>
        <v-icon>mdi-umbrella-outline</v-icon>
        <v-list-item-content>
          <v-list-item-title>
            <span
              style="
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 1rem;
              "
            >
              {{ this.calcProbability(this.precProbability) }} %
            </span>
          </v-list-item-title>
          <v-list-item-subtitle class="mt-n1 white--text">
            <span
              style="
                font-family: Roboto;
                font-style: normal;
                font-weight: 300;
                font-size: 0.875rem;
              "
              >Probabilidade de ocorrência de chuva</span
            >
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item-icon>
    </v-list-item>
  </v-card>
</template>

<script>
import moment from "moment";
export default {
  props: ["item", "cityId"],
  name: "CardWeatherForecast",
  data() {
    return {
      city: undefined,
      cities: undefined,
      isDay: undefined,
      icon: undefined,
      text: undefined,
      datetime: [],
      temp: undefined,
      precIntensity: undefined,
      precProbability: undefined,
      wind: undefined,
      summaryId: undefined,
      humidity: undefined,
      currentTime: undefined,
      day: undefined,
      month: undefined,
      year: undefined,
    };
  },
  watch: {
    item(value) {
      if (value) {
        this.initialize();
      }
    },
    cityId(value) {
      if (value) {
        this.initialize();
      }
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.$store.dispatch("loadCities");
      await this.$store.dispatch("loadHourlyCardForecastWeather", {
        id: this.cityId,
      });
      this.temp = "";
      this.precProbability = "";
      this.precIntensity = "";
      this.wind = "";
      this.humidity = "";
      this.summaryId = "";
      this.isDay = "";
      this.day = "";
      this.month = "";
      this.year = "";
      this.city = "";
      this.cities = "";

      this.cities = await this.$store.getters.cities;
      this.cities.find((item) => item.id === 4106902);
      this.city = this.cities.find((item) => this.cityId === item.citid);
      const resultado = await this.$store.getters.hourlyCardForecastWeather;
      const currentTime = moment().tz('America/Sao_Paulo').format("YYYYMMDDTHH");

      for (let index in resultado) {
        this.datetime.push(this.formateDateTime(resultado[index].datetime));
        if(this.datetime[index] == currentTime){
          this.temp = (resultado[index].value.temp).toFixed(0);
          this.precIntensity = (resultado[index].value.precIntensity).toFixed(1);
          this.precProbability = resultado[index].value.precProbability;
          this.humidity = resultado[index].value.humidity;
          this.icon = this.mapIcon(resultado[index].value.summaryId, resultado[index].datetime);
          this.text = this.mapText(resultado[index].value.summaryId);
          this.currentTime = this.formatCurrentTime(resultado[index].datetime);
        }
      }

      this.day = moment().format("DD");
      this.month = moment().locale("pt-br").format("MMMM");
      this.year = moment().format("YYYY");
    },
    calcProbability(x) {
      let res = x * 100;
      return res;
    },
    calcThermalSensation(temp, wind, humidity) {
      //X => temp, y => wind, z => humidity
      let res;
      if (temp < 20 && wind > 0.83) {
        res =
          13.12 +
          0.6215 * temp -
          11.37 * Math.pow(wind * 3.6, 0.16) +
          0.3965 * (temp * Math.pow(wind * 3.6, 0.16));
        return this.roundDecimal(res, 0);
      } else if (temp > 26 && humidity > 30) {
        res =
          (-42.379 +
            2.04901523 * (1.8 * temp + 32) +
            10.14333127 * humidity -
            0.22475541 * (1.8 * temp + 32) * humidity -
            ((6.83783 * 1) / Math.pow(10, 3)) * Math.pow(1.8 * temp + 32, 2) -
            ((5.481717 * 1) / Math.pow(10, 2)) * Math.pow(humidity, 2) +
            ((1.22874 * 1) / Math.pow(10, 3)) *
              Math.pow(1.8 * temp + 32, 2) *
              humidity +
            ((8.5282 * 1) / Math.pow(10, 4)) *
              (1.8 * temp + 32) *
              Math.pow(humidity, 2) -
            ((1.99 * 1) / Math.pow(10, 6)) *
              Math.pow(1.8 * temp + 32, 2) *
              Math.pow(humidity, 2) -
            32) /
          1.8;
          return this.roundDecimal(res, 0);
      } else {
        res = temp;
        return this.roundDecimal(res, 0);
      }
    },
    formatCurrentTime(x){
      let utc = moment(x).tz("America/Sao_Paulo").format("HH:00");
      return utc;
    },
    formateDateTime(x) {
      let utc = moment(x).tz("America/Sao_Paulo").format("YYYYMMDDTHH");
      return utc;
    },
    mapIcon(id, datetime) {
      let icon, isDay = true;
      let holder = moment(datetime, 'YYYY-MM-DDTHH:mm:ssZ').tz("America/Sao_Paulo").format("HH");
      if (holder <= '06' || holder >= '18') {
        isDay = false;
      }

      if (id == 4) {
        icon = "icon-infohidro-wi-cloud";
      } else if (id == 6) {
        icon = "icon-infohidro-wi-rain";
      } else if(id == 7){
        icon = "icon-infohidro-wi-thunderstorm";
      } else if (id == 8) {
        icon = "icon-infohidro-wi-snowflake-cold";
      } else if (id == 9) {
        icon = "icon-infohidro-wi-snow";
      } else if (id == 11) {
        icon = "icon-infohidro-wi-fog";
      } else if (id == 999) {
        icon = " ";
      }
      if (isDay == true) {
        if (id == 1) {
          icon = "icon-infohidro-wi-day-sunny";
        } else if (id == 2) {
          icon = "icon-infohidro-wi-day-sunny-overcast";
        } else if (id == 3) {
          icon = "icon-infohidro-wi-day-cloudy";
        } else if (id == 5) {
          icon = "icon-infohidro-wi-day-rain";
        } else if (id == 10) {
          icon = "icon-infohidro-wi-day-thunderstorm";
        } else if (id == 999) {
          icon = " ";
        }
      } else if (isDay == false) {
        if (id == 1) {
          icon = "icon-infohidro-wi-night-clear";
        } else if (id == 2) {
          icon = "icon-infohidro-wi-night-alt-partly-cloudy";
        } else if (id == 3) {
          icon = "icon-infohidro-wi-night-alt-cloudy";
        } else if (id == 5) {
          icon = "icon-infohidro-wi-night-alt-rain";
        } else if (id == 10) {
          icon = "icon-infohidro-wi-night-thunderstorm";
        } else if (id == 999) {
          icon = " ";
        }
      }
      return icon;
    },
    mapText(id) {
      let text;
      if (id == 4) {
        text = "Nublado";
      } else if (id == 6) {
        text = "Chuva";
      } else if (id == 7) {
        text = "Tempestade";
      } else if (id == 8) {
        text = "Geada";
      } else if (id == 9) {
        text = "Neve";
      } else if (id == 11) {
        text = "Neblina";
      } else if (id == 1) {
        text = "Céu Claro";
      } else if (id == 2) {
        text = "Poucas Nuvens";
      } else if (id == 3) {
        text = "Muitas Nuvens";
      } else if (id == 5) {
        text = "Parcialmente nublado com pancadas de chuva";
      } else if (id == 10) {
        text = "Parcialmente Nublado com chuvas e trovoadas";
      } else if(id == 999) {
        text = " ";
      }
      return text;
    },

    roundDecimal(num, places){
      return +(parseFloat(num).toFixed(places));
    }
  },
};
</script>

<style></style>
